/**
 * @typedef {object} PaginationStrategy
 * @property {function(ProductSearch):object} getNextPageCategory - Returns the category of the next url
 * @property {function(ProductSearch):string} getNextPageUrl - Returns the url of the next page
 * @property {function(ProductSearch):string} isLastPage - Returns true if the given page number is the last
 */

const validateRequiredMethod = (fn) =>
  // eslint-disable-next-line no-console
  fn || console.error('Required method no provided');

export default function createPaginationStrategy({
  getNextPageCategoryFn,
  getNextPageUrlFn,
  isLastPageFn,
}) {
  return {
    /**
     * Returns the category of the next url
     * @param {ProductSearch} productSearch target product search response
     * @returns {object} - Category object
     */
    getNextPageCategory: validateRequiredMethod(getNextPageCategoryFn),

    /**
     * Returns the url of the next page
     * @param {ProductSearch} productSearch target product search response
     * @returns {string} - url
     */
    getNextPageUrl: validateRequiredMethod(getNextPageUrlFn),

    /**
     * Returns true if the given page number is the last
     * @param {ProductSearch} productSearch target product search response
     * @returns {boolean} - true if it is the last page
     */
    isLastPage: validateRequiredMethod(isLastPageFn),
  };
}
